import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LoginResponseInterface } from '@interface/auth/login.interface';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { LOCAL_STORAGE_AUTH_KEY } from '@util/constants/local-storage.constants';
import { baseReducerActions } from '@util/data/base-reducer-actions';
import { isString } from '@util/data/is-exist';

import { initialAuthState } from './auth.initial-state';

const initialState = initialAuthState(localStorage.getItem(LOCAL_STORAGE_AUTH_KEY));

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    ...baseReducerActions(initialState),
    setData: (state, { payload: { data } }: PayloadAction<ResponseDataInterface<LoginResponseInterface>>) => {
      state.data = data;
      if (isString(data.token)) localStorage.setItem(LOCAL_STORAGE_AUTH_KEY, data.token);
    },
    logout: (state) => {
      localStorage.removeItem(LOCAL_STORAGE_AUTH_KEY);
      state.data = initialAuthState().data;
    },
  },
});

export const authActions = authSlice.actions;
